<template>
    <div class="m-calendar__b-popup" v-if="cell">
        <div class="calendar__popup m-calendar__popup">
            <calendar-popup-body :cell="cell"></calendar-popup-body>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';

	import CalendarPopupBody from "../CalendarPopupBody.vue";

    export default {
		components: {CalendarPopupBody},
		name: 'CalendarMobilePopup',
        computed: {
			...mapGetters({
				cell: 'popupCell',
            }),
        },
    }
</script>
